import { exampleUser, User } from '../user';

export interface Organization {
  id: number;
  name: string;
  abbreviation: string;
  owner: User;
  createdAt: number;
}

export const exampleOrganization: Organization = {
  id: 1,
  name: 'Drive Social Media',
  abbreviation: 'DSM',
  owner: exampleUser,
  createdAt: +new Date(),
};
